// extracted by mini-css-extract-plugin
module.exports = {"inheritedProps":"xKaIb","mixes-in-title":"_2XPqY","mixesInTitle":"_2XPqY"};